import styled, { css } from "styled-components";

const bp = {
  md: "768px",
  lg: "1024px",
};

/* DARK THEME */
const colors = {
  bg: "#000000",
  text: "#ffffff",
  accent: "#d4af37",
  line: "rgba(255,255,255,0.16)",
  hover: "rgba(255,255,255,0.08)",
  gold: "#8b8064",
};

export const NavWrap = styled.nav`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  width: 100%;
  z-index: 1000;
  background: ${({ $phase }) =>
    $phase === "overlay" ? "transparent" : colors.bg};
  transition: background 220ms ease, box-shadow 220ms ease,
    border-color 220ms ease;
  border-bottom: 1px solid
    ${({ $phase }) => ($phase === "overlay" ? "transparent" : colors.line)};
  box-shadow: ${({ $phase }) =>
    $phase === "overlay" ? "none" : "0 6px 20px rgba(0,0,0,0.6)"};
  backdrop-filter: ${({ $phase }) =>
    $phase === "overlay" ? "none" : "saturate(1.05) blur(6px)"};
`;

export const Spacer = styled.div`
  height: ${({ $phase }) => ($phase === "overlay" ? "86px" : "64px")};
  @media (max-width: ${bp.md}) {
    height: 56px;
  }
`;

export const NavInner = styled.div`
  width: 100%;
  height: ${({ $phase }) => ($phase === "overlay" ? "86px" : "64px")};
  padding: 0 8px;
  display: grid;
  grid-template-columns: auto 1fr auto;
  align-items: center;
  gap: 8px;
  transition: height 220ms ease;

  @media (max-width: ${bp.md}) {
    grid-template-columns: 1fr auto;
    height: 56px;
    background: ${colors.bg};
  }
`;

export const LogoWrap = styled.a`
  display: inline-flex;
  align-items: center;
  gap: 10px;
  color: ${colors.text};
  text-decoration: none;

  img {
    height: ${({ $phase }) => ($phase === "overlay" ? "44px" : "32px")};
    width: auto;
    display: block;
    transition: height 220ms ease;
  }
`;

export const baseLink = css`
  text-decoration: none;
  color: ${({ $phase }) => ($phase === "overlay" ? "#000" : colors.text)};
  font-weight: 500;
  letter-spacing: 0.2px;
  padding: 8px 6px;
  border-radius: 8px;
  transition: transform 0.15s ease, background 0.15s ease, opacity 0.2s ease;
  font-size: 17px;
  opacity: ${({ $phase }) => ($phase === "overlay" ? 0.75 : 1)};

  &:hover {
    background: ${({ $phase }) =>
      $phase === "overlay" ? "transparent" : colors.hover};
  }
`;

export const NavLink = styled.a`
  ${baseLink}
`;

export const PhoneLink = styled.a`
  ${baseLink}
  border: 1px solid ${({ $phase }) =>
    $phase === "overlay" ? "#00000044" : colors.line};
  border-radius: 999px;
  padding: 8px 12px;
  white-space: nowrap;
  @media (max-width: ${bp.md}) {
    display: none;
  }
`;

export const IconBtn = styled.button`
  width: 36px;
  height: 36px;
  border-radius: 8px;
  border: 1px solid
    ${({ $phase }) => ($phase === "overlay" ? "transparent" : colors.line)};
  background: ${({ $phase }) =>
    $phase === "overlay" ? "transparent" : colors.bg};
  display: grid;
  place-items: center;
  cursor: pointer;
  transition: background 0.15s ease, border-color 0.2s ease, opacity 0.2s ease;
  opacity: ${({ $phase }) => ($phase === "overlay" ? 0.8 : 1)};

  &:hover {
    background: ${({ $phase }) =>
      $phase === "overlay" ? "rgba(255, 255, 255, 0.06)" : colors.hover};
  }

  svg {
    color: ${({ $phase }) => ($phase === "overlay" ? "#000" : colors.text)};
  }
`;

export const MeniuBtn = styled(IconBtn)`
  position: relative;

  span {
    position: absolute;
    left: 9px;
    right: 9px;
    height: 2px;
    background: ${colors.gold};
    border-radius: 2px;
    transition: transform 0.2s ease, opacity 0.2s ease;
  }

  span:nth-child(1) {
    top: 11px;
  }
  span:nth-child(2) {
    top: 17px;
  }
  span:nth-child(3) {
    top: 23px;
  }

  @media (min-width: ${bp.lg}) {
    display: none;
  }
`;

export const Left = styled.div`
  display: flex;
  align-items: center;
  min-width: 0;
`;

export const BrandText = styled.span`
  margin-top: 8px;
  font-size: 20px;
  font-family: "Dancing Script", cursive;
  font-weight: 600;
  white-space: nowrap;
  color: ${({ $phase }) => ($phase === "overlay" ? "#000" : colors.text)};
  opacity: ${({ $phase }) => ($phase === "overlay" ? 0.85 : 1)};
  transition: color 220ms ease, opacity 220ms ease;

  @media (max-width: ${bp.md}) {
    font-size: 19px;
    margin-top: 10px;
  }
`;

export const NavList = styled.ul`
  display: none;
  align-items: center;
  gap: 18px;
  list-style: none;
  padding: 0;
  margin: 0;

  @media (min-width: ${bp.lg}) {
    display: flex;
    justify-content: center;
  }
`;

export const NavItem = styled.li``;

export const Right = styled.div`
  position: relative;
  display: flex;
  align-items: center;
  justify-self: end;
  gap: 10px;

  @media (max-width: ${bp.md}) {
    gap: 6px;
  }
`;

export const LangSwitcherWrap = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  border: 1px solid ${colors.line};
  border-radius: 999px;
  padding: 4px 8px;
  font-size: 14px;
  font-weight: 600;
  color: ${colors.text};
  cursor: pointer;
  transition: background 0.2s ease;

  &:hover {
    background: ${colors.hover};
  }

  @media (max-width: ${bp.md}) {
    display: none;
  }
`;

export const FloatLang = styled.div`
  position: fixed;
  right: 14px;
  bottom: calc(14px + env(safe-area-inset-bottom, 0px));
  z-index: 9999;
  display: flex;
  align-items: center;
  gap: 6px;
  border: 1px solid ${colors.line};
  background: rgba(17, 17, 17, 0.9);
  backdrop-filter: blur(8px) saturate(1.1);
  padding: 6px 10px;
  border-radius: 999px;
  box-shadow: 0 6px 18px rgba(0, 0, 0, 0.35);
  opacity: ${({ $visible }) => ($visible ? 1 : 0)};
  transform: translateY(${({ $visible }) => ($visible ? "0" : "6px")});
  pointer-events: ${({ $visible }) => ($visible ? "auto" : "none")};
  transition: opacity 0.25s ease, transform 0.25s ease;
  will-change: transform, opacity;

  @media (min-width: ${bp.md}) {
    display: none;
  }
`;

export const MobilePanel = styled.aside`
  position: absolute;
  top: 100%;
  right: 0;
  background: #111;
  border-radius: 0 0 8px 8px;
  box-shadow: 0 6px 18px rgba(0, 0, 0, 0.3);
  padding: 12px 0;
  width: 220px;
  transform: scaleY(${(p) => (p.$open ? 1 : 0)});
  transform-origin: top;
  transition: transform 0.2s ease;
  z-index: 1000;
`;

export const MobileList = styled.ul`
  list-style: none;
  margin: 0;
  padding: 0;
  display: flex;
  flex-direction: column;
`;

export const MobileItem = styled.li``;

export const MobileLink = styled.a`
  display: block;
  padding: 12px 18px;
  color: #fff;
  text-decoration: none;
  font-weight: 600;
  font-size: 0.95rem;
  transition: background 0.2s ease;

  &:hover {
    background: rgba(255, 255, 255, 0.08);
  }
`;

/* ===== Phone (desktop) ===== */
export const PhoneBtn = styled.button`
  ${baseLink}
  display: inline-flex;
  align-items: center;
  gap: 8px;
  border: 1px solid
    ${({ $phase }) => ($phase === "overlay" ? "#00000044" : colors.line)};
  border-radius: 999px;
  padding: 8px 12px;
  background: ${({ $phase }) =>
    $phase === "overlay" ? "transparent" : colors.bg};
  cursor: pointer;
  @media (max-width: ${bp.md}) {
    display: none;
  }

  svg {
    color: ${({ $phase }) => ($phase === "overlay" ? "#000" : colors.text)};
  }
`;

export const PhonePanel = styled.div`
  position: absolute;
  top: calc(100% + 8px);
  right: 0;
  width: 240px;
  background: #111;
  border: 1px solid ${colors.line};
  border-radius: 12px;
  box-shadow: 0 10px 28px rgba(0, 0, 0, 0.38);
  padding: 8px;
  transform-origin: top right;
  transform: scale(${(p) => (p.$open ? 1 : 0.96)});
  opacity: ${(p) => (p.$open ? 1 : 0)};
  pointer-events: ${(p) => (p.$open ? "auto" : "none")};
  transition: transform 0.18s ease, opacity 0.18s ease;
`;

export const PhoneList = styled.ul`
  list-style: none;
  margin: 0;
  padding: 0;
  display: grid;
  gap: 6px;
  li a {
    display: block;
    width: 100%;
    text-decoration: none;
    color: ${colors.text};
    font-weight: 700;
    letter-spacing: 0.3px;
    background: ${colors.hover};
    padding: 10px 12px;
    border-radius: 10px;
  }
`;

/* ===== Float Phone (mobil + desktop, mereu activ DOAR la DELIVERY) ===== */
export const FloatPhoneWrap = styled.div`
  position: fixed;
  right: 14px;
  bottom: 14px;
  z-index: 10010;
  opacity: ${({ $visible }) => ($visible ? 1 : 0)};
  transform: translateY(${({ $visible }) => ($visible ? "0" : "6px")});
  pointer-events: ${({ $visible }) => ($visible ? "auto" : "none")};
  transition: opacity 0.25s ease, transform 0.25s ease;
  will-change: transform, opacity;
  @media (max-width: ${bp.md}) {
    bottom: calc(72px + env(safe-area-inset-bottom, 0px)); /* peste RO/EN */
  }
`;

export const FloatPhoneBtn = styled.button`
  position: fixed;
  right: 14px;
  bottom: calc(14px + env(safe-area-inset-bottom, 0px));
  min-width: 46px;
  height: 46px;
  border-radius: 999px;
  border: 1px solid ${colors.line};
  background: ${colors.accent};
  color: ${colors.text};
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
  padding: 0 12px;
  box-shadow: 0 6px 18px rgba(0, 0, 0, 0.35);
  cursor: pointer;

  /* eticheta */
  .label {
    font-weight: 800;
    font-size: 14px;
    letter-spacing: 0.2px;
    white-space: nowrap;
  }

  @media (max-width: ${bp.md}) {
    position: static; /* păstrează comportamentul anterior pe mobil */
    right: auto;
    bottom: auto;
    margin-left: auto; /* îl aliniază la dreapta dacă e într-un container inline */
  }
`;

export const FloatPhonePanel = styled.div`
  position: absolute;
  right: 0;
  bottom: 56px;
  display: grid;
  gap: 6px;
  padding: 8px;
  width: 230px;
  background: rgba(17, 17, 17, 0.96);
  border: 1px solid ${colors.line};
  border-radius: 14px;
  box-shadow: 0 10px 28px rgba(0, 0, 0, 0.38);
  transform-origin: bottom right;
  transform: scale(${(p) => (p.$open ? 1 : 0.96)});
  opacity: ${(p) => (p.$open ? 1 : 0)};
  pointer-events: ${(p) => (p.$open ? "auto" : "none")};
  transition: transform 0.18s ease, opacity 0.18s ease;
  z-index: 10001; /* peste tot */

  a {
    text-decoration: none;
    color: ${colors.text};
    font-weight: 800;
    letter-spacing: 0.3px;
    background: ${colors.hover};
    padding: 10px 12px;
    border-radius: 10px;
  }
`;
